module.exports = __webpack_public_path__ + "static/media/activity-icon-execute-ruling.8fe51c4a.svg";